import environment from "../../../settings/environment";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, put, PutEffect, select } from "redux-saga/effects";
import { setUser } from "../../ducks/user";
import { clearString } from "../../../utils/functions";
import api from "../../../settings/api";
import { ReducersTypes } from "@/redux/reducers/Models";

export interface Fetch {
    document: string;
    pin: string;
    callback: (success: boolean, errorMessage?: string) => void;
}

export interface ValidatePinAction {
    type: string;
    payload: Fetch;
}

export default function* validatePin({
    payload,
}: ValidatePinAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const getUser = (state: ReducersTypes) => state.userReducer;
        // @ts-expect-error
        const user: ReducersTypes['userReducer'] = yield select(getUser);

        const data = {
            companyIdentification: environment.api.companyIdentification,
            userIdentification: environment.api.userIdentification,
            document: clearString(payload.document),
            pinCode: payload.pin,
            channel: environment.api.channel,
        };
        const response = yield call(api.post, `/v1/customers/pins/validate`, data);

        if (response?.data?.status?.codigoRetorno === 0 && response?.data?.data?.accessToken) {
            yield put(setUser({
                ...user,
                accessTokenTickets: response?.data?.data?.accessToken,
            }));
            yield call(payload.callback, true);
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}